import { render } from "./FileIcons.vue?vue&type=template&id=0f406052&scoped=true"
import script from "./FileIcons.vue?vue&type=script&lang=js"
export * from "./FileIcons.vue?vue&type=script&lang=js"

import "./FileIcons.vue?vue&type=style&index=0&id=0f406052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f406052"]])

export default __exports__